import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import UnitSelector from 'src/component/UI/UnitSelector';
import FeatureFence from 'src/component/FeatureFence';

interface FilterBarProps {
  includeGrid?: boolean;
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  onStartDateChange?: (date: moment.Moment | null) => void;
  onEndDateChange?: (date: moment.Moment | null) => void;
}

export default function FilterBar (props: FilterBarProps) {
  const {
    includeGrid,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
  } = props;

  const inner = (
    <Paper>
      <FeatureFence can='eht-process-data'>
        <UnitSelector
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
        />
      </FeatureFence>
    </Paper>
  );

  if (includeGrid) {
    return (
      <Grid item xs={12} md={12}>
        {inner}
      </Grid>
    );
  }

  return inner;
}

FilterBar.propTypes = {
  includeGrid: PropTypes.bool
};

FilterBar.defaultProps = {
  includeGrid: false
};
